import { Button, TextField } from '@mui/material';
import { isEmptyString } from 'lib/typeguards';
import React from 'react';
import { PatternFormat } from 'react-number-format';
import { Row } from 'ui/Flex';

interface TransactionExpiryInputProps {
    onChange: (value?: string) => void;
    value?: string;
    disabled?: boolean;
    size?: 'small' | 'medium';
    paper?: boolean;
}

function isValidExpiry(value?: string) {
    return !value || value.length === 7;
}

export const TransactionExpiryInput: React.FC<TransactionExpiryInputProps> = ({
    onChange,
    value,
    disabled,
    paper,
    size
}) => {
    const [field, setField] = React.useState(value);
    const handleValueChange = React.useCallback((vals: { formattedValue: string }) => {
        setField(vals.formattedValue);
    }, []);
    const handleClick = React.useCallback(() => {
        onChange(isEmptyString(field) ? undefined : field);
    }, [field, onChange]);
    const renderButton = React.useCallback(
        () => (
            <Button
                disabled={(value === field && isValidExpiry(value)) || disabled}
                onClick={handleClick}
                variant="outlined"
                size={size}
                sx={{ mr: size === 'small' ? -1 : 0 }}
            >
                {value === field || field.length ? 'Submit' : 'Clear'}
            </Button>
        ),
        [disabled, field, handleClick, size, value]
    );
    return (
        <Row>
            <PatternFormat
                format="##/20##"
                mask="_"
                customInput={TextField}
                variant="outlined"
                value={field}
                size={size}
                onValueChange={handleValueChange}
                label="Card Expiry"
                sx={{ backgroundColor: paper ? 'background.paper' : undefined }}
                InputProps={{ endAdornment: renderButton() }}
                InputLabelProps={{ shrink: !!field }}
                disabled={disabled}
            />
        </Row>
    );
};
